import React, { useState, useEffect } from "react";
import "./ShiftJobTable.scss";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import EyeIcon from "../../../../asset/jobs/EyeIcon.svg";
import CrossIcon from "../../../../asset/jobs/close-circle.svg";
import { CircularProgress, Modal, Box, Typography } from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import styles from "./ShiftJobTable.module.scss";
import {
  setJobModal,
  setJobDetaialsModal,
  setShiftLogsModal,
} from "../../../../redux/userReducer";
import JobOptionModel from "../../../Common/JobModal/JobModal";
import JobDetailsModal from "../../../Common/JobDetailsModal/JobDetailsModal";
import JobShiftPostDetails from "../../../PopUp/JobShiftPostDetails/JobShiftPostDetails";
import dayjs from "dayjs";
import DisputeModal from "./DisputeModal";
import SuccessModal from "./SuccessModal";
import ActionLogsModal from "./ActionLogsModal";
import graphqlRequest from "../../../../requestMethod";
import JobPostDetailsModal from "../../../PopUp/JobPostDetailsModal/JobPostDetailsModal";
import { pushEvent } from "../../../../utils/clevertap";

const columns = [
  { id: "jobId", label: "Job ID", minWidth: 100 },
  // {
  //   id: "department",
  //   label: "Department ",
  //   minWidth: 100,
  //   align: "center",
  //   format: (value) => value.toLocaleString("en-US"),
  // },
  {
    id: "specialization",
    label: "Specialization",
    minWidth: 100,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "professionalName",
    label: "Professional Name ",
    minWidth: 100,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "startDateTime",
    label: "Shift Start Date & Time",
    minWidth: 100,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "endDateTime",
    label: "Shift End Date & Time",
    minWidth: 100,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "inTime",
    label: "Check In-Date & Time",
    minWidth: 100,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "outTime",
    label: "Check Out-Date & Time",
    minWidth: 100,
    align: "center",
    format: (value) => value.toFixed(2),
  },
  {
    id: "totalCost",
    label: "Total cost",
    minWidth: 50,
    align: "center",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  },
  {
    id: "actualJobHours",
    label: "Actual Job Hours",
    minWidth: 50,
    align: "center",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  },
  { id: "status", label: "Approval Status", minWidth: 100, align: "center" },
  { id: "action", label: "Action", minWidth: 100, align: "center" },
];

function createData(
  jobId,
  // department,
  specialization,
  professionalName,
  // date,
  startDateTime,
  endDateTime,
  inTime,
  outTime,
  totalCost,
  // endDate,
  status,
  id,
  department,
  profession,
  branch,
  userId,
  approvedAt,
  disputedReason,
  disputedComment,
  disputedCreatedAt,
  resolvedReason,
  resolvedComment,
  resolvedApprovedAt,
  jD,
  allData,
  actualJobHours,
) {
  return {
    jobId,
    // department,
    specialization,
    professionalName,
    // date,
    startDateTime,
    endDateTime,
    inTime,
    outTime,
    totalCost,
    // endDate,
    status,
    id,
    department,
    profession,
    branch,
    userId,
    approvedAt,
    disputedReason,
    disputedComment,
    disputedCreatedAt,
    resolvedReason,
    resolvedComment,
    resolvedApprovedAt,
    jD,
    allData,
    actualJobHours,
  };
}

const rows = [
  createData(
    "JO1234567",
    "Cardiology",
    "Safari Sharma",
    "Safari",
    "19/12/2022",
    "NA",
  ),
];

function ShiftJobTable({
  loading,
  filterTable,
  removeOpenJob,
  fetchShiftLogs,
  totalData,
  currentPage,
  limit,
  setCurrentPage,
  setLimit,
  setDownloadTable,
  updateShiftApprovalStatus,
  handleApprove,
  handleDispute,
  filterByStatus,
  onClearFilters,
}) {
  console.log("filterTableShiftLogs", filterTable);
  let newRow = filterTable?.map((data) =>
    createData(
      data?.code,
      // data?.department,
      data?.specialization,
      data?.user,
      // `${dayjs(Number(data?.date)).format('MMM D, YYYY, h:mm A')}`,

      // new Date(Number(data?.startDateTime)).toDateString().split(" ").slice(1).join(" "),
      // new Date(Number(data?.endDateTime)).toDateString().split(" ").slice(1).join(" "),
      `${dayjs(Number(data?.startDateTime)).format("MMM D, YYYY, h:mm A")}`,
      `${dayjs(Number(data?.endDateTime)).format("MMM D, YYYY, h:mm A")}`,
      `${dayjs(Number(data?.in)).format("MMM D, YYYY, h:mm A")}`,
      `${dayjs(Number(data?.out)).format("MMM D, YYYY, h:mm A")}`,

      // new Date(Number(data?.in)).toLocaleTimeString().split(",")[0],
      // new Date(Number(data?.out)).toLocaleTimeString().split(",")[0],
      data?.cost,
      data?.approved,
      // new Date(Number(data.end)).toLocaleString().split(",")[0],
      data.id,
      data?.department,
      data?.profession,
      data?.branch,
      data?.userId,
      data?.approvedAt,
      data?.disputedReason,
      data?.disputedComment,
      data?.disputedCreatedAt,
      data?.resolvedReason,
      data?.resolvedComment,
      data?.resolvedApprovedAt,
      data?.job?.jobDescription,
      data,
      data?.actualJobHours,
    ),
  );
  console.log("newRow-->", newRow);

  let { jobModal, detailsJobModal, shiftLogsModal } = useSelector(
    (state) => state.user,
  );
  let dispatch = useDispatch();
  const handleClose = () => dispatch(setJobModal());
  let data = localStorage.getItem("auth");
  let token = JSON.parse(data)?.accessToken;
  const handleCloseDetail = () => dispatch(setJobDetaialsModal());
  const handleCloseShiftDetail = () => dispatch(setShiftLogsModal());
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [successType, setSuccessType] = useState("single");
  const [currentShift, setCurrentShift] = useState(null);
  const [showLogsModal, setShowLogsModal] = useState(false);

  //table checking start...
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedShift, setSelectedShift] = useState(null);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(+event.target.value);
    setCurrentPage(0);
  };

  let [openDate, setOpenDate] = useState(false);
  let [selectedData, setSelectedData] = useState({});
  let [jobPostRemoveId, setJobPostRemoveId] = useState({});
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  let handleView = (data) => {
    setSelectedData(data);
    dispatch(setJobDetaialsModal());
  };

  let handleJobPostDelete = (data) => {
    setJobPostRemoveId(data);
    dispatch(setJobModal());
  };

  useEffect(() => {
    if (Array.isArray(newRow)) {
      setDownloadTable(newRow);
    }
  }, [newRow?.length]);

  const [selected, setSelected] = React.useState([]);

  // Handle batch approval of selected shifts
  const handleApproveSelected = async () => {
    if (selected.length === 0) return;

    try {
      // Call the approve function for each selected ID
      await Promise.all(
        selected.map((id) => {
          const row = newRow.find((r) => r.id === id);
          return handleApprove(row);
        }),
      );

      // Clear selection after approval
      setSelected([]);

      // Show success message
      setSuccessMessage(
        `${selected.length} shift(s) have been successfully approved.`,
      );
      setSuccessType("single");
      setShowSuccessModal(true);

      // Refresh data and clear filters
      if (fetchShiftLogs) {
        // This will trigger the parent component to clear its filters
        if (onClearFilters) {
          onClearFilters();
        } else {
          // Fallback to just refreshing the data if onClearFilters is not provided
          fetchShiftLogs();
        }
      }
    } catch (error) {
      console.error("Error approving selected shifts:", error);
      setSuccessMessage(
        `Failed to approve shifts: ${error.message || "Unknown error"}`,
      );
      setSuccessType("error");
      setShowSuccessModal(true);
    }
  };

  // Handle select all rows
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = newRow.map((n) => n.id);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  // Handle click on a single row
  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const getStatusBadge = (status) => {
    const statusConfig = {
      PENDING_APPROVAL: {
        text: "Pending",
        className: styles.pendingBadge,
      },
      PENDING_VERIFICATION: {
        text: "Pending Verification",
        className: styles.pendingVerificationBadge,
      },
      APPROVED: {
        text: "Approved",
        className: styles.approvedBadge,
      },
      RESOLVED: {
        text: "Approved",
        className: styles.approvedBadge,
      },
      DISPUTED: {
        text: "Disputed",
        className: styles.disputedBadge,
      },
      REJECTED: {
        text: "Rejected",
        className: styles.rejectedBadge,
      },
      CANCELLED: {
        text: "Cancelled",
        className: styles.cancelledBadge,
      },
    };

    const config = statusConfig[status] || {
      text: status,
      className: styles.defaultBadge,
    };

    return (
      <span className={`${styles.statusBadge} ${config.className}`}>
        {config.text}
      </span>
    );
  };
  // const handleApprove = async (shiftId) => {
  //   try {
  //     // Call the updateShiftApprovalStatus function passed from parent
  //     const result = await updateShiftApprovalStatus([shiftId]);

  //     if (result.success) {
  //       // Update local state to reflect the approval
  //       setFilterTable(prevTable =>
  //         prevTable.map(shift =>
  //           shift.id === shiftId ? { ...shift, approved: 'Approved' } : shift
  //         )
  //       );

  //       // Show success message
  //       setSuccessMessage(`Shift ${shiftId} has been successfully approved.`);
  //       setSuccessType("single");
  //       setShowSuccessModal(true);

  //       // Refresh the data
  //       if (fetchShiftLogs) {
  //         fetchShiftLogs();
  //       }
  //     } else {
  //       throw new Error(result.message || 'Failed to approve shift');
  //     }
  //   } catch (error) {
  //     console.error('Error in handleApprove:', error);
  //     setSuccessMessage(`Failed to approve shift: ${error.message}`);
  //     setSuccessType("error");
  //     setShowSuccessModal(true);
  //   }
  // };

  // const handleDispute = (shift) => {
  //   // setCurrentShift(shift)
  //   setShowDisputeModal(true)
  // }

  const handleDisputeSubmit = async (category, comment) => {
    if (!currentShift) return; // Add a guard clause

    const disputeReason = category === "Others" ? comment : category;
    const updatedShift = {
      ...currentShift,
      comment,
      category,
    };

    const result = await handleDispute(updatedShift, (shiftId) => {
      setShowDisputeModal(false);
      pushEvent("Web_Shift_Disputed", {
        page: "Shift Logs Job",
        section: "Jobs",

        // ✅ Shift Info
        shiftId: updatedShift?.allData?.id,
        jobCode: updatedShift?.allData?.code,
        profession: updatedShift?.allData?.profession,
        department: updatedShift?.allData?.department,
        specialization: updatedShift?.allData?.specialization,

        shiftDate: updatedShift?.allData?.date,
        shiftStart: updatedShift?.allData?.startDateTime,
        shiftEnd: updatedShift?.allData?.endDateTime,

        checkIn: updatedShift?.allData?.in,
        checkOut: updatedShift?.allData?.out,

        cost: updatedShift?.allData?.cost,
        approvalStatus: updatedShift?.allData?.approved,

        branch: updatedShift?.allData?.branch,

        // ✅ Dispute Info (important for this event)
        disputedReason: updatedShift?.allData?.disputedReason,
        disputedComment: updatedShift?.allData?.disputedComment,

        // ✅ Professional (User)
        userId: updatedShift?.allData?.professional?.id,
        name: updatedShift?.allData?.professional?.name?.full,
        specialization_user:
          updatedShift?.allData?.professional?.specialization?.name,
        experience: updatedShift?.allData?.professional?.numExperience?.name,
        qualification: updatedShift?.allData?.professional?.qualification?.name,
        professionalType:
          updatedShift?.allData?.professional?.professionalType?.name,

        registrationNumber:
          updatedShift?.allData?.professional?.professionalRegistration?.number,

        // ✅ Job (light)
        jobId: updatedShift?.allData?.job?.id,
        jobStart: updatedShift?.allData?.job?.start,
        jobEnd: updatedShift?.allData?.job?.end,

        contactPerson: updatedShift?.allData?.job?.contactDetail?.contactPerson,
      });
      setSuccessMessage(`Shift has been successfully disputed.`);
      setSuccessType("single");
      // setShowDisputeModal(true);

      setTimeout(() => {
        if (fetchShiftLogs) {
          fetchShiftLogs();
        }
      }, 500);
    });

    if (result && !result.success) {
      throw new Error(result.message || "Failed to dispute shift");
    }
  };
  const handleShowLogs = (shift) => {
    // setCurrentShift(shift)
    setSelectedShift(shift);
    setShowLogsModal(true);
  };
  const handleApproveClick = async (row) => {
    try {
      const result = await handleApprove(row, (shiftId) => {
        // This callback runs on success
        pushEvent("Web_Shift_Approved", {
          page: "Shift Logs Job",
          section: "Jobs",

          // ✅ Shift Info
          shiftId: row?.id,
          jobCode: row?.jobId,
          profession: row?.profession,
          department: row?.department,
          specialization: row?.specialization,

          shiftStart: row?.startDateTime,
          shiftEnd: row?.endDateTime,
          checkIn: row?.inTime,
          checkOut: row?.outTime,

          cost: row?.totalCost,
          approvalStatus: row?.status,
          approvedAt: row?.approvedAt,

          branch: row?.branch,

          // ✅ User
          userId: row?.userId,
          name: row?.professionalName,

          // ✅ Optional (analytics)
          action: "shift_approved",
        });
        setSuccessMessage(`Shift has been successfully approved.`);
        setSuccessType("single");
        setShowSuccessModal(true);

        // Refresh the data after a short delay to ensure the backend has processed the update
        setTimeout(() => {
          if (fetchShiftLogs) {
            fetchShiftLogs();
          }
        }, 500);
      });

      // If we get here, there was an error (since success would have triggered the callback)
      if (result && !result.success) {
        throw new Error(result.message || "Failed to approve shift");
      }
    } catch (error) {
      console.error("Error in handleApproveClick:", error);
      setSuccessMessage(
        `Failed to approve shift: ${error.message || "Unknown error"}`,
      );
      setSuccessType("error");
      setShowSuccessModal(true);
    }
  };
  const handleDisputeClick = async (row) => {
    try {
      setShowDisputeModal(true);

      // const result = await handleDispute(row, (shiftId) => {
      // setShowDisputeModal(false)

      //   // This callback runs on success
      //   setSuccessMessage(`Shift has been successfully disputed.`);
      //   setSuccessType("single");
      //   setShowDisputeModal(true);

      //   // Refresh the data after a short delay to ensure the backend has processed the update
      //   setTimeout(() => {
      //     if (fetchShiftLogs) {
      //       fetchShiftLogs();
      //     }
      //   }, 500);
      // });

      // If we get here, there was an error (since success would have triggered the callback)
      // if (result && !result.success) {
      //   throw new Error(result.message || 'Failed to dispute shift');
      // }
    } catch (error) {
      console.error("Error in handleApproveClick:", error);
      // setSuccessMessage(`Failed to approve shift: ${error.message || 'Unknown error'}`);
      // setSuccessType("error");
      setShowDisputeModal(true);
    }
  };

  return (
    <>
      {filterByStatus === "PENDING_APPROVAL" && selected.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 16px",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px 4px 0 0",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <div>{selected.length} shift(s) selected</div>
          <button
            onClick={handleApproveSelected}
            style={{
              backgroundColor: "#2D5FA1",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "#1e4b8f",
              },
            }}
          >
            Approve Selected
          </button>
        </div>
      )}
      <div className="openjob-table">
        <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 5 }}>
          <TableContainer
            sx={{
              maxHeight: "calc(100vh - 300px)",
              minHeight: "calc(100vh - 300px)",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {filterByStatus === "PENDING_APPROVAL" && (
                    <TableCell
                      padding="checkbox"
                      style={{
                        position: "sticky",
                        right: 0,
                        paddingLeft: 15,
                        zIndex: 2,
                        backgroundColor: "#2D5FA1",
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "18px",
                        color: "#FFFFFF",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={
                          filterTable.length > 0 &&
                          selected.length === filterTable.length
                        }
                        onChange={handleSelectAllClick}
                        inputProps={{ "aria-label": "select all jobs" }}
                      />
                    </TableCell>
                  )}
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        ...(column.id === "action" && {
                          position: "sticky",
                          right: 0,
                          zIndex: 2,
                          backgroundColor: "#2D5FA1",
                        }),
                        minWidth: column.minWidth,
                        backgroundColor: "#2D5FA1",
                        fontSize: "16px",
                        fontWeight: "500",
                        lineHeight: "18px",
                        color: "#FFFFFF",
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {loading ? (
                <CircularProgress sx={{ position: "absolute", left: "50%" }} />
              ) : (
                <TableBody>
                  {newRow?.length > 0 ? (
                    newRow
                      ?.slice
                      // page * rowsPerPage,
                      // page * rowsPerPage + rowsPerPage
                      ()
                      .map((row, index) => {
                        console.log("row", row);

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.code}
                          >
                            {filterByStatus === "PENDING_APPROVAL" && (
                              <TableCell
                                padding="checkbox"
                                style={{ paddingLeft: 15 }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isSelected(row.id)}
                                  onChange={(event) =>
                                    handleClick(event, row.id)
                                  }
                                  inputProps={{
                                    "aria-labelledby": `enhanced-table-checkbox-${index}`,
                                  }}
                                />
                              </TableCell>
                            )}
                            {columns.map((column) => {
                              const value = row[column.id];
                              return column.id === "action" ? (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{
                                    position: "sticky",
                                    right: 0,
                                    background: "#fff",
                                    // zIndex: 2,
                                  }}
                                >
                                  {row.status === "PENDING_APPROVAL" ? (
                                    <div className={styles.actionButtons}>
                                      <button
                                        className={styles.approveBtn}
                                        onClick={() => handleApproveClick(row)}
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className={styles.disputeBtn}
                                        onClick={() => {
                                          setCurrentShift(row); // Save the current row data in state if not already done
                                          handleDisputeClick(row);
                                        }}
                                      >
                                        Dispute
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      className={styles.viewLogsBtn}
                                      onClick={() => handleShowLogs(row)}
                                      title="View Logs"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: "0 auto",
                                      }}
                                    >
                                      <svg
                                        className={styles.eyeIcon}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                </TableCell>
                              ) : (
                                <TableCell key={column.id} align={column.align}>
                                  {column.id === "professionalName" ? (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        fontWeight: 500,
                                        color: "#1e4f8a",
                                      }}
                                      onClick={() => {
                                        handleView(row);
                                      }}
                                    >
                                      {value}
                                    </span>
                                  ) : column.format &&
                                    typeof value === "number" ? (
                                    column.format(value)
                                  ) : column.id === "status" ? (
                                    getStatusBadge(value)
                                  ) : (
                                    value
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })
                  ) : (
                    // <p style={{ position: "absolute", left: "50%" }}>
                    //   {" "}
                    //   No Data Found
                    // </p>
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        sx={{
                          textAlign: { xs: "left", sm: "center" },
                          borderBottom: "none",
                          height: {
                            xs: "calc(100vh - 200px)",
                            sm: "calc(100vh - 300px)",
                          },
                          verticalAlign: "middle",
                          p: { xs: 2, sm: 0 },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: { xs: "flex-start", sm: "center" },
                            justifyContent: "center",
                            height: "100%",
                            width: "100%",
                            textAlign: { xs: "left", sm: "center" },
                            pl: { xs: 8, sm: 0 },
                          }}
                        >
                          <WorkOutlineIcon
                            sx={{
                              fontSize: { xs: 40, sm: 60 },
                              color: "primary.main",
                              mb: 2,
                              ml: { xs: 9, sm: 0 },
                            }}
                          />
                          <Typography
                            variant="h6"
                            component="p"
                            gutterBottom
                            sx={{ ml: { xs: 14, sm: 0 } }}
                          >
                            No Shift Logs Found
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              my: 3,
                              fontSize: { xs: "12px", sm: "14px" },
                              lineHeight: { xs: "1.3", sm: "1.5" },
                              maxWidth: { xs: "200px", sm: "none" },
                              wordBreak: "break-word",
                              textAlign: "center",
                            }}
                          >
                            There are currently no shift logs available to
                            display.
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            paginationMode="server"
            pagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={totalData}
            rowsPerPage={limit}
            page={currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            // rowsPerPageOptions={[10, 25, 100]}
            // component="div"
            // count={newRow?.length}
            // rowsPerPage={rowsPerPage}
            // page={page}
            // onPageChange={handleChangePage}
            // onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
      <Modal
        open={jobModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobOptionModel
          removeOpenJob={removeOpenJob}
          jobPostRemoveId={jobPostRemoveId}
        />
      </Modal>
      <Modal
        open={detailsJobModal && selectedData?.id}
        onClose={handleCloseDetail}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobPostDetailsModal
          handleCloseDetail={handleCloseDetail}
          selectedData={selectedData}
          routeName={"ShiftJob"}
        />
      </Modal>

      <Modal
        open={shiftLogsModal}
        onClose={handleCloseShiftDetail}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <JobShiftPostDetails
          handleCloseDetail={handleCloseShiftDetail}
          selectedData={selectedData}
          fetchShiftLogs={fetchShiftLogs}
        />
      </Modal>
      {showDisputeModal && (
        <DisputeModal
          shift={columns}
          onClose={() => setShowDisputeModal(false)}
          onSubmit={handleDisputeSubmit}
        />
      )}
      {showLogsModal && (
        <ActionLogsModal
          shift={selectedShift}
          onClose={() => {
            setShowLogsModal(false);
            setSelectedShift(null);
          }}
        />
      )}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        message={successMessage}
        type={successType}
      />
    </>
  );
}

export default ShiftJobTable;
